import { inject, Injectable, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppError } from '@/app/core/http/app-error.model';
import { toAppError } from '@/app/core/http/error-catalog';
import { SettlementLoadForm } from '../models/settlement.model';
import { SettlementRepository } from '../services/settlement.repository';

export type SettlementLoadFormStatus = 'loading' | 'ready' | 'error';

const ERROR_SUBJECT = 'los datos de la carga';

@Injectable()
export class SettlementLoadFormStore {
  private readonly repository = inject(SettlementRepository);

  private readonly _status = signal<SettlementLoadFormStatus>('loading');
  private readonly _form = signal<SettlementLoadForm | null>(null);
  private readonly _paymentBranchId = signal<number | null>(null);
  private readonly _error = signal<AppError | null>(null);

  private request?: Subscription;

  readonly status = this._status.asReadonly();
  readonly form = this._form.asReadonly();
  readonly paymentBranchId = this._paymentBranchId.asReadonly();
  readonly error = this._error.asReadonly();

  load(): void {
    this.request?.unsubscribe();
    this._error.set(null);
    this._status.set('loading');

    this.request = this.repository.getLoadForm().subscribe({
      next: (form) => {
        this._form.set(form);
        this._paymentBranchId.set(form.defaultPaymentBranchId);
        this._status.set('ready');
      },
      error: (cause: unknown) => {
        this._form.set(null);
        this._paymentBranchId.set(null);
        this._error.set(toAppError(cause, ERROR_SUBJECT));
        this._status.set('error');
      },
    });
  }

  selectPaymentBranch(id: number | null): void {
    this._paymentBranchId.set(id);
  }
}
